import { render, staticRenderFns } from "./CabecalhoGenerico.vue?vue&type=template&id=03c69ff7&scoped=true&"
import script from "./CabecalhoGenerico.vue?vue&type=script&lang=js&"
export * from "./CabecalhoGenerico.vue?vue&type=script&lang=js&"
import style0 from "./CabecalhoGenerico.vue?vue&type=style&index=0&id=03c69ff7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c69ff7",
  null
  
)

export default component.exports